import React from 'react';

const SearchIcon: React.FC = () => (
  <svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.516689 3.99112L0.516689 2.99112L11.2172 2.99112L9.62106 1.44828L10.3526 0.74117L12.4845 2.80184L12.5472 2.74123L13.2787 3.44834L13.216 3.50895L13.2788 3.5696L12.5472 4.2767L12.4845 4.21606L10.3526 6.27677L9.62102 5.56966L11.2541 3.99112L0.516689 3.99112Z" fill="#007EFF"/>
  </svg>
);

export default SearchIcon;
